<template>

	<figure class="card">

		<div class="card-img" v-if="cardImg">
			<img :src="cardImg" :alt="cardImg" v-if="cardImg">
			<img src="https://via.placeholder.com/280x400/ccc/38BD23?text=image not found" :alt="cardImg">
		</div>

		<div class="card-img" v-else>
			<img src="https://via.placeholder.com/280x400/ccc/38BD23?text=image not found" :alt="cardImg">
		</div>

		<div class="card-status" v-if="cardStatus"> Online</div>

		<figcaption class="card-caption" v-if="cardName || cardAge">

			<div class="card-name" v-if="cardName"> {{ cardName }} </div>

			<div class="card-age" v-if="cardAge">{{ cardAge }} years </div>

		</figcaption>

	</figure>

</template>

<script>
import src from "../controllers/components/CardCtrl";
export default src;
</script>